export const MessageUltis = {
   formaterMessage(msg) {
      const msgParse = JSON.parse(msg);
      return {
         ...msgParse,
         data: JSON.parse(msgParse.data)
      };
   },
   addMessageToConversations(conversations = [], messages = []) {
      // messages là 1 mảng. duyệt từng phần tử để thêm vào từng conversation;
      messages.forEach((msg) => {
         const { threadId, message, createdAt, socialId, isMessageFromPage } = msg;
         // kiểm tra conversation đã có chưa. chưa có thì add thêm vào list;
         const indexConver = conversations.findIndex(f => f.threadId === threadId);
         if (indexConver !== -1) {
            const conversation = conversations[indexConver];
            let arrMsg = conversation.messages;
            // kiểm tra tin nhắn trong conversation, tồn tại thì ghi đè lên, còn không thì thêm vào danh sách;
            const indexMsg = arrMsg?.findIndex(f => f.socialId === socialId);
            if (indexMsg !== -1) {
               arrMsg[indexMsg] = msg;
            } else {
               arrMsg = [msg, ...arrMsg]
            }
            //copy thành 1 conversations mới tránh lỗi immutability redux
            conversations = conversations.map((m, index) => {
               if (index === indexConver) {
                  return {
                     ...m,
                     message,
                     messages: arrMsg,
                     createdAt,
                     isMessageFromPage
                  }
               }
               return m;
            })
         } else {
            conversations = [...conversations, msg];
         }
      });
      return conversations;
   },
   sortConversation(conversations = []) {
      return conversations.sort((a, b) => {
         try {
            return b.timestamp - a.timestamp;
         } catch (error) { }
         return 0;
      })
   },
   updateTempMessage(conversations = [], messages = [], tempId) {
      // messages là 1 mảng. duyệt từng phần tử để thêm vào từng conversation;
      messages.forEach((msg) => {
         const { threadId, message, createdAt, isMessageFromPage } = msg;
         // kiểm tra conversation đã có chưa. chưa có thì add thêm vào list;
         const indexConver = conversations.findIndex(f => f.threadId === threadId);
         if (indexConver !== -1) {
            const conversation = conversations[indexConver];
            let arrMsg = conversation.messages;
            // kiểm tra tin nhắn trong conversation, tồn tại thì ghi đè lên, còn không thì thêm vào danh sách;
            const indexMsg = arrMsg?.findIndex(f => f.tempId === tempId);
            if (indexMsg !== -1) {
               arrMsg[indexMsg] = msg;
            } else {
               arrMsg = [msg, ...arrMsg]
            }
            //copy thành 1 conversations mới tránh lỗi immutability redux
            conversations = conversations.map((m, index) => {
               if (index === indexConver) {
                  return {
                     ...m,
                     message,
                     messages: arrMsg,
                     createdAt,
                     isMessageFromPage
                  }
               }
               return m;
            })
         } else {
            conversations = [...conversations, msg];
         }
      });
      return conversations;
   },
   addTempMessage(conversations = [], messages = []) {
      // messages là 1 mảng. duyệt từng phần tử để thêm vào từng conversation;
      messages.forEach((msg) => {
         const { threadId, message, createdAt, socialId, isMessageFromPage } = msg;
         // kiểm tra conversation đã có chưa. chưa có thì add thêm vào list;
         const indexConver = conversations.findIndex(f => f.threadId === threadId);
         if (indexConver !== -1) {
            const conversation = conversations[indexConver];
            let arrMsg = conversation.messages;
            arrMsg = [msg, ...arrMsg];
            //copy thành 1 conversations mới tránh lỗi immutability redux
            conversations = conversations.map((m, index) => {
               if (index === indexConver) {
                  return {
                     ...m,
                     message,
                     messages: arrMsg,
                     createdAt,
                     isMessageFromPage
                  }
               }
               return m;
            })
         } else {
            conversations = [...conversations, msg];
         }
      });
      return conversations;
   }
}